import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
  signal,
} from '@angular/core';

import {
  APP_LOCKUP_ON_LIGHT_URL,
  APP_LOCKUP_SHELL_URL,
  APP_NAME,
} from '../../constants/app-branding.constants';
import { ThemeService } from '../../services/theme/theme.service';
import { resetAppState } from '../../utils/reset-app-state';

/**
 * Escape-hatch UI when `BootHealthService.phase()` is `'stalled'`.
 * Charcoal shell + elevated canvas card (same ladder as auth).
 */
@Component({
  selector: 'app-boot-error',
  templateUrl: './app-boot-error.html',
  styleUrl: './app-boot-error.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppBootErrorComponent {
  readonly stuckSignals = input<readonly string[]>([]);

  readonly keepWaiting = output<void>();
  readonly reload = output<void>();

  private readonly theme = inject(ThemeService);

  protected readonly resetting = signal(false);
  protected readonly brandName = APP_NAME;

  /** Dark mark on light canvas; white mark on dark canvas. */
  protected readonly canvasLockupUrl = computed(() =>
    this.theme.theme() === 'dark' ? APP_LOCKUP_SHELL_URL : APP_LOCKUP_ON_LIGHT_URL
  );

  protected onKeepWaiting(): void {
    this.keepWaiting.emit();
  }

  protected onReload(): void {
    this.reload.emit();
  }

  protected async onResetAndReload(): Promise<void> {
    if (this.resetting()) return;
    this.resetting.set(true);
    try {
      await resetAppState();
    } finally {
      const reload = (window as unknown as { __reloadWithFreshShell?: () => void })
        .__reloadWithFreshShell;
      if (typeof reload === 'function') {
        reload();
      } else {
        window.location.reload();
      }
    }
  }
}
